<template>
  <div class="p-3 m-0" id="add-company">
                

    <div class="row">
      
<div style="font-size:16px;font-weight:bold;text-align:left;padding-left:15px;">Add New Company:</div>
<hr>
    <div class="col-12" style="font-weight:bold;text-align:left;">Select Company:</div>
    <div class="col-md-6 col-lg-3">
                  <b-form-group
                    class="exo-regular field-headings"
                    :label="'Select to Add new Company'" >
                    <w-dropdown
                      class="width-control"
                      :options="partnerList"
                      @dropdownChange="getPartner($event)"
                      :selected="iform.partner"
                    />
                  </b-form-group>
                </div>
    </div>
    <div class="row">
    <div class="col-12" style="font-weight:bold;text-align:left;">Select Category Details:</div>
                <div class="col-md-6 col-lg-3">
                  <b-form-group
                    class="exo-regular field-headings"
                    :label="'Business Category'">
                    <w-dropdown
                      class="width-control"
                      :disabled="!iform.partner"
                      :options="iform.primaryBusinessList"
                      @dropdownChange="getPrimaryBusiness($event)"
                      :selected="iform.primaryBusiness"
                    />
                  </b-form-group>
                </div>
                
                <div class="col-md-6 col-lg-3" v-if="!isCustomerSelected">
                  <b-form-group
                    class="exo-regular field-headings"
                    :label="'Select Primary Business Type'">
                    <w-dropdown
                      class="width-control"
                      :disabled="!iform.partner"
                      :options="iform.primaryBusinessTypeList"
                      @dropdownChange="getPrimaryBusinessType($event)"
                      :selected="iform.primaryBusinessType"
                    />
                  </b-form-group>
                </div>
    </div>
    
    <div class="row" v-if="false" >
                 <div class="col-md-6 col-lg-3">
                  <b-form-group
                    class="exo-regular field-headings"
                    :label="$t('REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.SECONDARY_BUSINESS')">
                    <w-dropdown
                      :disabled="iform.primaryBusiness == null"
                      class="width-control"
                      :options="iform.secondaryBusinessList"
                      @dropdownChange="getSecondaryBussiness($event)"
                      :selected="iform.secondaryBusiness"
                      :search="true"
                    />
                  </b-form-group>
                </div>
                <div class="col-md-6 col-lg-3">
                  <b-form-group
                    class="exo-regular field-headings"
                    :label="'Select secondary business type'">
                    <w-dropdown
                      class="width-control"
                      :disabled="iform.primaryBusiness == null"
                      :options="iform.secondaryBusinessTypeList"
                      @dropdownChange="getSecondaryBusinessType($event)"
                      :selected="iform.secondaryBusinessType"
                    />
                  </b-form-group>
                </div>
    </div>

    
    <div class="row" v-if="!isCustomerSelected">     
    <div class="col-12" style="font-weight:bold;text-align:left;">Select Vertical Details:</div> 
                <div class="col-md-6 col-lg-3">
                  <b-form-group class="source-sans-pro field-headings" label="Business Vertical">
                    <w-dropdown
                      class="width-control-small"
                      :options="bussinessVertical"
                      @dropdownChange="getBusinessVerticalValue($event,i)"
                      :selected="primaryCedCode"
                      :disabled="!iform.partner"
                    />
                  </b-form-group>
                </div>

                <div class="col-md-6 col-lg-3">
                  
                  <div>
                    <w-multi-select-dropdown
                      :ref="'multiselectRef'"
                      :labelText="'Region'"
                      :labelClass="'label-class'"
                      :position="'bottom'"
                      :sourceFrom="'general'"
                      :selectionType="true"
                      :optionFields="bussinessRegionDropDown.get(i)"
                      :disabled="!primaryCedCode"
                      @selectedMultiselectEvent="getMultiSelectedDropdown($event,0)"
                      :defaultValue="''"
                    />
                  </div>
                </div>

                
                <div class="col-md-6 col-lg-3">
                  <!-- {{form.otherGroup.verticals[i].primaryVertical}} -->
                  <b-form-group class="source-sans-pro field-headings" label="Primary Business">
                    <w-dropdown
                      class="width-control-small"
                      :options="primaryBussinessData[0]"
                      :disabled="!form.otherGroup.verticals[0].clusterCode"
                      @dropdownChange="getPrimaryBussinessValue($event,i)"
                      :selected="primaryVertical"
                    />
                  </b-form-group>
                </div>
    </div>
    <div class="row">      
                <div class="col-12" style="text-align: left;">
                  <button class="btn btn-success" :disabled="!validateSubmit()" @click="saveNewCompany()">Submit</button>
                </div>
    </div>
<hr>
<div style="font-size:16px;font-weight:bold;text-align:left;">Existing Company List:</div>
    <div class="my-custom-scrollbar table-responsive">
      <table class="table table-striped mb-0">
        <thead>
          <tr>
            <th scope="col">Sl No</th>
            <th scope="col">Company Name</th>
            <th scope="col">Category</th>
            <th scope="col">Is Default</th>
            <th scope="col">New or Migration</th>
            <th scope="col">Reference Number</th> 
            <th scope="col">Status</th> 
            <th scope="col">Inserted On</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody class="text-left table-body">
          <tr v-for="(e,index) in partnerExistingCompanyList" :key="index">
            <td scope="col">{{index+1}}</td>
            <td scope="col">{{e.companyDesc}}</td>
            <td scope="col">{{e.categoryDesc}}</td>
            <td scope="col">{{e.isDefault == 'Y' ? 'Default Company' : '-'}}</td>
            <td scope="col">{{e.isMigration}}</td>
            <td scope="col">{{e.documentNumber}}</td>
            <td scope="col">{{e.status}}</td>
            <td scope="col">{{formatDateTime(e.insertedOn, 'T')}}</td>
            <td scope="col"><span style="text-decoration:underline;color:blue;cursor:pointer;white-space: nowrap;" 
            @click="resubmitAddCompany(e.categoryCode, e.companyCode)" 
            v-if="(e.isDefault != 'Y') && (e.statusCode == 'N' || 
            e.statusCode == 'S')">
             {{e.statusCode == 'S' ? 'Re-' : ''}} Submit for approval</span></td>
            
          </tr>
        </tbody>
      </table>
    </div>
    </div>
</template>

<script>
import axios from "axios";


import { OnBoardingServices } from "../../services/onBoardingService";
const OnBoardingService = new OnBoardingServices();
import DropDown from "../../widgets/DropDown";
import multiSelect from "../../widgets/multiSelect";
import TextInput from "../../widgets/TextInput.vue";
import { PartnerService } from "../../services/partnerService";
import { RegistrationService } from "../../services/RegistrationService.js";
import { DashboardService } from '../../services/DashboardService';
const RegisterService = new RegistrationService();
const partnerService = new PartnerService();
const dashboardService = new DashboardService();
export default {
  components: {
    "w-multi-select-dropdown": multiSelect,
    "w-dropdown": DropDown,
    "w-text-input": TextInput
  },
  data() {
    return { 
      isCustomerSelected: false,
      partnerExistingCompanyList: [],
      partnerId:'',
      primaryBussinessData: [],
      selectedMultiselectValue: [],
      checkBussinessVertical:false,
      defaultCompanyBusinessTypeLists:[],
      primaryCedCode: null,
      primaryVertical: null,
      secondaryCedCode: null,
      currentCompanyCode: 1,
      categoryCode: 2,
      bussinessRegionDropDown: new Map(),
      panel: 0,
      iform: {
      secondaryBusinessList:[{ text: "Select One", value: null, disabled: true }],
      primaryBusinessList:[{ text: "Select One", value: null, disabled: true }],
      primaryBusinessTypeList: [{ text: "Select One", value: null, disabled: true }],
      secondaryBusinessTypeList: [{ text: "Select One", value: null, disabled: true }],
      secondaryBusinessType:null,
      primaryBusinessType:null,
      secondaryBusiness:null,
      primaryBusiness:null,
        primaryCategory: [],
        primarySubCategory: [],
        secondaryCategory: [],
        secondarySubCategory: [],
        country: {},
        countryCode: null,
        nationalId: null,
        currencyCode: null,
        identityNumber: null,
        identityCode: null,
        organizationName: "",
        coordinationPersonName: "",
        designation: "",
        mobileNumber: "",
        email: "",
        url: "",
        // User details
        userName: "",
        password: "",
        reEnterPassword: "",
        otp: "",
        duns: null,
        specializedPrimaryCategory: null,
        partner: null
      },
      form: {
        organisationDetail: {
          registeredOfficeAddress: {
            streetAddress: null,
            cityCode: null,
            stateCode: null,
            countryCode: null,
            postalCode: null
          },
          correspondenceAddress: {
            streetAddress: null,
            cityCode: null,
            stateCode: null,
            countryCode: null,
            postalCode: null
          },
          factoryDetail: [],
          wareHouse: [],
          statutory: {
            certificateEffectiveFrom: null,
            certificateEffectiveUpto: null,
            enterpriseSectorCode: null,
            investedAmount: null,
            incorporatedAs: null,
            yearIncorporation: null,
            placeIncorporation: null
          },

          gstNumber: null,
          cinNumber: null,
          llpinNumber:null,
          frnNumber:null,
          sernNumber:null,
          isMsme: 'N',
          isEinvoiceApplicable: 'Y',
          isTCSApplicable:'Y',
          msmeNumber: null,
          gstinDocumentId: null,
          tanNumber: null,
          tanDocumentId: null,
          vatNumber: null,
          vatDocumentId: null,

          pfRegistrationId: null,
          pfRegionalOffice: null,
          esiRegistrationId: null,
          esiRegionalOffice: null,
          pfEmployeeCount: null,
          esiRemarks: null,

          factoryInspectorCfNo: null,
          shopEstablishmentCfNo: null,
          yearCommencementMfg: null,
          partnerContactDetail: [],
          branch: []
        },

        bankDetailGroup: {
          accounts: []
        },
        partnerShipAvenueGroup: {
          customers: [],
          projects: [],
          subdivisions: [],
          documentId: null
        },

        otherGroup: {
          partnerWithLnt: null,
          lntEmpInOrgn: null,
          odDetail: [],
          verticals: [{"businessType":""}],
          employees: [],
          reference: [
            {
              designation: null,
              email: null,
              miscDetailCode: null,
              mobileNumber: null,
              referredCompanyName: null,
              referredName: null,
              slno: 0
            }
          ]
        }
      },
      selectedCompany:'',
      partnerList: [{ text: "Select One", value: null, disabled: true }],
      branchLogIn: false,
      companycode: "",
      partnerNumber: "",
      loading: false,
      addBussinessVertical: [{}],
      bussinessVertical: [],
      bussinessRegion: [],
    };
  },
  computed: {
  },
  created() {
    this.getPartnerInfo();
    this.loading = true;
    var self = this
    EventBus.$on('switchCompany',function(e){      
    //self.getPartnerInfo();
    })
    // this.getQuickLinkPage();
  },
  methods: {
    resubmitAddCompany(cat,comp,pid){
      var data = {
  "categoryCode": cat,
  "companyCode": comp,
  "partnerId": this.partnerId
}
var self = this;
      
      OnBoardingService.resubmitAddCompany(data).then(resp => {
        if (resp.failureMessage != '') {
            window.alert(resp.failureMessage)
            self.$router.go(0)
        } else {
            window.alert(resp.response)  
            self.$router.go(0)        
        }
        })
        .catch(err => {});
    },
    formatDateTime(dt, splitter){ 
      console.log(dt)
      var dateArray = (dt.split(splitter)[0]).split('-')
      var timeArray = (dt.split(splitter)[1]).split(':')
      var date = dateArray[2]
      var month = dateArray[1]
      var year = dateArray[0] 
      var h = timeArray[0]
      var m = timeArray[1]
      
      var ampm = (h >= 12) ? "PM" : "AM"
      h = ((h > 12) ? h-12 : h)
      h = (h.toString()).length == 1 ? ('0'+h) : h
      return (date + '-' + month + '-' + year) + ' ' + h + ":" + m + " " + ampm;
    },
    getMultiSelectedDropdown(event, i) {
      this.bussinessRegionDropDown[i] = [];
      this.form.otherGroup.verticals[0].clusterCode = [];
      let multiSelectedValues = [];
      let slectedVAlues = [];
      multiSelectedValues = event;
      this.selectedMultiselectValue[i] = event;
      if (multiSelectedValues.length > 0) {
        this.checkBussinessVertical = true;
        var dummyData = [];
        multiSelectedValues.forEach((element, i) => {
          slectedVAlues.push(element.value);
          dummyData.push({
            text: element.name,
            value: element.value
          });
        });
        this.$forceUpdate();
        this.primaryBussinessData[i] = dummyData;
      }

      this.form.otherGroup.verticals[0].clusterCode = slectedVAlues;
      if (i != 0) {
       // this.form.otherGroup.verticals[i].primaryVertical = null;
      }
    },
    getPartner(event) {
      var self = this
        
      this.iform.partner = event;
      self.iform.primaryBusinessList= [{ text: "Select One", value: null, disabled: true }]
      self.iform.secondaryBusinessList= [{ text: "Select One", value: null, disabled: true }]
      self.iform.primaryBusinessTypeList= [{ text: "Select One", value: null, disabled: true }]
      self.iform.secondaryBusinessTypeList= [{ text: "Select One", value: null, disabled: true }]
      self.iform.secondaryBusiness = null
      self.iform.primaryBusiness = null
      self.iform.primaryBusinessType = null
      self.iform.secondaryBusinessType = null
      self.primaryBussinessData=[]      
      self.addBussinessVertical= [{}]
      self.bussinessVertical= []
      self.bussinessRegion= []
      self.selectedMultiselectValue= []
      self.checkBussinessVertical=false
      self.primaryCedCode= null
      self.primaryVertical= null
      self.getBussinessVerticals();
      self.defaultCompanyBusinessTypeLists= []

      RegisterService.getAvailableCategories(self.partnerId, event).then(resp => {
        let res = resp.response;
        self.defaultCompanyBusinessTypeLists = resp.response
        if(res.length == 0){
          window.alert('All categories for the company "'
           + self.partnerList.filter(x=>x.value==event)[0].text + '" already added')
        }
        for (let i = 0; i < res.length; i++) {
         // if(res[i].categoryDesc != 'Customer') {
            self.iform.primaryBusinessList.push({
              text: res[i].categoryDesc,
              value: res[i].categoryCode
            });
          //}
        }
      });
    },
    getBusinessTypeValue(event, i) {
      this.checkBussinessVertical = true;
      //this.form.otherGroup.verticals[i].businessType = event;
    },

    getBusinessVerticalValue(event, i) {
      //this.bussinessRegionDropDown.delete(i);
      //this.primaryBussinessData[i] = [];
      //this.bussinessVertical.filter(x=>x.id.cedCode == event)[0].
      
      this.checkBussinessVertical=false
      this.primaryVertical= null
      this.primaryBussinessData = []
      this.checkBussinessVertical = true;
      this.primaryCedCode = event;
      this.getBussinessRegions(event, i);
    },
    getBussinessRegions(businessType, i) {
      OnBoardingService.getBussinessRegion(businessType, this.iform.partner).then(resp => {
        if (resp) {
          var bussinessData = [];
          resp.response.forEach(project => {
            bussinessData.push({
              name: project.longDesc,
              value: project.id.cedCode
            });
            // this.$forceUpdate();
            // this.bussinessRegion[i] = bussinessData;
            this.$forceUpdate();
            this.bussinessRegionDropDown.set(i, bussinessData);
          });
        }
      });
    },
    
    getbussinessTypes(cat, comp,type) {
      var self = this
      var catBList = self.defaultCompanyBusinessTypeLists.filter(x=>x.categoryCode==cat)[0]
      
          this.iform.primaryBusinessTypeList=[]
          if(!(catBList.defaultCompanyBusinessTypeList) && cat !=5) {
            window.alert("No categories to choose. Kindly ensure same partner type is added in parent company first.")
          } 
          if (cat==5) {
            self.isCustomerSelected = true    
          }
          catBList.defaultCompanyBusinessTypeList.forEach((bussiness, i) => {
            this.iform.primaryBusinessTypeList.push({
              text: bussiness.longDesc,
              value: bussiness.id
            });
          });
      /*dashboardService.getBusinessTypes(
        comp,cat
      ).then(resp => {
        if (type == 'primary') {
          this.iform.primaryBusinessTypeList=[]
          resp.response.forEach((bussiness, i) => {
            this.iform.primaryBusinessTypeList.push({
              text: bussiness.longDesc,
              value: bussiness.id
            });
          });
        } else {
          this.iform.secondaryBusinessTypeList=[]
          resp.response.forEach(bussiness => {
            this.iform.secondaryBusinessTypeList.push({
              text: bussiness.longDesc,
              value: bussiness.id
            });
          });
        }
      });*/
    },
    getBussinessVerticals() {
      var self = this
      OnBoardingService.getBussinessVertical(this.iform.partner).then(resp => {
        resp.response.forEach(project => {
          self.bussinessVertical.push({
            text: project.longDesc,
            value: project.id.cedCode
          });
        });
      });
    },
    bindBussinessVertical(clusterCode, i) {
      var selectedBussiness = [];
      var primaryBussiness = [];
      if (clusterCode != null) {
        if (
          this.bussinessRegionDropDown.get(i) &&
          this.bussinessRegionDropDown.get(i).length > 0
        ) {
          this.bussinessRegionDropDown.get(i).forEach(element => {
            clusterCode.forEach(cluster => {
              if (element.value == cluster) {
                selectedBussiness.push({
                  name: element.name,
                  value: element.value
                });
                primaryBussiness.push({
                  text: element.name,
                  value: element.value
                });
                this.primaryBussinessData[i] = primaryBussiness;
              }
            });
          });
        }
        return selectedBussiness;
      }
    },
    getTerms(business, type) {
      RegisterService.getTerms(this.iform.partner, business).then(resp => {
        if (resp.response) {
          this.termsConditionsValue = [];
          this.termsConditionsValue.push(
            resp.response.replace(/\n/g, "<br />")
          );
          // this.termsConditionsValue.splice(
          //   0,
          //   1,business + '<br>' +
          //   resp.response.replace(/\n/g, "<br />")
          // );
        } else {
          this.termsConditionsValue = [];
        }
      });
    },
    getSecondaryBussiness(event) {
      this.iform.secondaryBusiness = event;
      this.iform.secondaryBusinessType= [{ text: "Select One", value: null, disabled: true }]
      this.getbussinessTypes(event, this.iform.partner, 'secondary');
      this.getTerms(event, "secondary");
    },  
    getSecondaryBusinessType(e) {
      this.iform.secondaryBusinessType = e
    },
    getPrimaryBusinessType(e){
      this.iform.primaryBusinessType = e
    },
    getPrimaryBusiness(event) {
      var self = this
      this.iform.primaryBusiness = event;
      self.iform.secondaryBusinessList= [{ text: "Select One", value: null, disabled: true }]
      self.iform.primaryBusinessTypeList= [{ text: "Select One", value: null, disabled: true }]
      self.iform.secondaryBusinessTypeList= [{ text: "Select One", value: null, disabled: true }]
      this.getbussinessTypes(event, this.iform.partner, 'primary');
      this.iform.specializedPrimaryCategory = null;
      this.getTerms(event, "primary");
      if(event != 5){
      RegisterService.getBussiness(this.iform.partner).then(resp => {
        let res = resp.response;
        self.iform.secondaryBusinessList = [
          { text: "Select One", value: null, disabled: true }
        ];
        self.iform.secondaryCategory = [];
        self.iform.secondarySubCategory = [];
        for (let i = 0; i < res.length; i++) {
          if (self.iform.primaryBusiness == res[i].categoryCode) {
          } else { 
            self.iform.secondaryBusinessList.push({
              text: res[i].longDesc,
              value: res[i].categoryCode
            });
          }
        }
      });
      }
    },
    getPartnerExistingCompanyList(pid){
      var self = this
      RegisterService.getPartnerExistingCompanyList(pid).then(resp => {
        self.partnerExistingCompanyList = resp.response;
      });
    },
    getPartnerList(pid) {
      var self = this
      RegisterService.getPartnerAvailableList(pid).then(resp => {
        let res = resp.response;
        for (let i = 0; i < res.length; i++) {
          self.partnerList.push({
            text: res[i].companyDesc,
            value: res[i].companyCode
          });
        }
      });
    },
    saveNewCompany(){
      if((!this.isCustomerSelected && (this.iform.partner && this.iform.primaryBusiness && this.iform.primaryBusinessType &&
      this.primaryCedCode && this.primaryBussinessData.length > 0 && this.primaryVertical))      
      || (this.isCustomerSelected && this.iform.primaryBusiness)) {
      var data = {
        "businessType": this.isCustomerSelected ? null : this.iform.primaryBusinessType,
        "categoryCode": this.iform.primaryBusiness,
        "cedCode": this.isCustomerSelected ? null : this.primaryCedCode,
        "clusterList": this.isCustomerSelected ? null : this.primaryBussinessData[0].map(x=>x.value),
        "companyCode": this.iform.partner,
        "partnerId": this.partnerId,
        "primaryVertical": this.isCustomerSelected ? null : this.primaryVertical
      }
      var self = this
      RegisterService.saveNewProfile(data).then(resp => {
        let res = resp.response;
          if (resp.status == "SUCCESS") {
            window.alert(res)
            self.$router.go(0)
          } else { 
            window.alert(resp.failureMessage)
            self.$router.go(0)
          }
        })
        .catch(err => {
          this.loading = false;          
        window.alert('Error submitting. please try again later.')
        });
        
      } else {
        window.alert('Please select all required fields and try again.')
      }

    },
    validateSubmit(){
      if(this.isCustomerSelected){
        return true
      }
      if(this.iform.partner && this.iform.primaryBusiness && this.iform.primaryBusinessType &&
      this.primaryCedCode && this.primaryBussinessData.length > 0 && this.primaryVertical) {
        console.log(this.iform.partner)
        console.log(this.iform.primaryBusiness)
        console.log(this.iform.primaryBusinessType)
        console.log(this.primaryCedCode)
        console.log(this.primaryBussinessData)
        console.log(this.primaryVertical)
        return true
      } else {
        return false
      }
    },
    getPrimaryBussinessValue(event, i) {
      this.primaryVertical = event;
    },
    getPartnerInfo() { 
      partnerService.getPartnerInfo().then(resp => {
        this.companycode = resp.response.currentCompanyCode;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
        this.partnerNumber = resp.response.partnerNumber;
        this.partnerId = resp.response.partnerId;
        this.getPartnerList(resp.response.partnerId);
        this.getPartnerExistingCompanyList(resp.response.partnerId);
        if (resp.response.partnerCategory == "B") {
          this.branchLogIn = true;
        } else {
          this.branchLogIn = false;
        }
      });
    },
  }
};
</script>
<style>
#add-company legend{text-align: left !important;font-size:13px;}
</style>